import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations, contactInfo, navItems } from "../i18n/translations";

export default function Footer() {
  const { t } = useLanguage();
  const tx = translations.footer;

  return (
    <footer className="bg-[#1F1F1D] text-[#C9B789] py-20">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <h3
              className="text-[#F5F0E8] text-[26px] tracking-[0.3em] mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
            >
              N A C U I I
            </h3>
            <p
              className="text-[#9C8456] text-[10px] tracking-[0.4em] uppercase mb-6"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.tagline)}
            </p>
            <p
              className="text-[#C9B789]/75 text-[15px] leading-[1.8] max-w-md"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(tx.description)}
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4
              className="text-[#9C8456] text-[10px] tracking-[0.4em] uppercase mb-6"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.navTitle)}
            </h4>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.key}>
                  <a
                    href={item.href}
                    className="text-[#F5F0E8]/80 text-[14px] hover:text-[#F5F0E8] transition-colors"
                    style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                  >
                    {t(translations.nav[item.key])}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4
              className="text-[#9C8456] text-[10px] tracking-[0.4em] uppercase mb-6"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.contactTitle)}
            </h4>
            <p
              className="text-[#F5F0E8] text-[15px] mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
            >
              NACUII Residence
            </p>
            {contactInfo.emails.map((email) => (
              <a
                key={email}
                href={`mailto:${email}`}
                className="block text-[#C9B789]/75 text-[14px] hover:text-[#F5F0E8] transition-colors mb-1"
                style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
              >
                {email}
              </a>
            ))}
            <div className="mt-3 mb-6">
              {contactInfo.phones.map((phone) => (
                <a
                  key={phone}
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  className="block text-[#C9B789]/75 text-[14px] hover:text-[#F5F0E8] transition-colors"
                  style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                >
                  {phone}
                </a>
              ))}
            </div>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-[#9C8456]/50 flex items-center justify-center hover:bg-[#9C8456] hover:border-[#9C8456] transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 text-[#C9B789]" strokeWidth={1.4} />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-[#9C8456]/50 flex items-center justify-center hover:bg-[#9C8456] hover:border-[#9C8456] transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4 text-[#C9B789]" strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#3a3a36] flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[#C9B789]/60 text-[12px] tracking-wider"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
          >
            © {new Date().getFullYear()} NACUII — {t(tx.rights)}
          </p>
          <p
            className="text-[#C9B789]/60 text-[11px] tracking-[0.3em] uppercase"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
          >
            {t(tx.listing)}
          </p>
        </div>
      </div>
    </footer>
  );
}
